import React from "react";
import { BadgeOutlined } from "@mui/icons-material";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";

const fileNameFromUrl = (url) => {
  if (!url) return undefined;
  try {
    const last = new URL(url).pathname.split("/").filter(Boolean).pop();
    return last ? decodeURIComponent(last.replace(/\+/g, " ")) : undefined;
  } catch {
    return undefined;
  }
};

// /**
//  * Rows for {@link DocumentsSection} on company registration overview — URLs + labels + icons.
//  */
export const buildOverviewDocuments = (company, msg, doc) => {
  const rows = [];
  const add = (rowKey, url, name, icon) => {
    if (!url) return;
    const fileName = fileNameFromUrl(url);
    rows.push({
      rowKey,
      name,
      url,
      icon,
      ...(fileName ? { fileName } : {}),
    });
  };

  add(
    "delegation-document",
    company?.company_owner?.delegation_document_url || doc?.delegation_document_url,
    msg.delegationDocument,
    <DescriptionOutlinedIcon />,
  );
  add(
    "personal-id-document",
    company?.company_owner?.personal_id_url || doc?.personal_id_url,
    msg.idDocument,
    <BadgeOutlined />,
  );
  add(
    "commercial-record",
    company?.commercial_record_url,
    msg.commercialRecordDocument,
    <AccountBalanceOutlinedIcon />,
  );

  return rows;
};
